import * as voucherEdit from '../services/voucherEdit';
import dayjs from 'dayjs';

//生成唯一id
function guid() {
  return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
    36,
  );
}

export default {
  namespace: 'voucherEdit',
  state: {
    typeList: [
      { name: '满减券', value: 'CASH_COUPON' },
      { name: '折扣券', value: 'DISCOUNT_COUPON' },
      //目前团购券不支持
      // { name: '团购券', value: 'GROUP_COUPON' },
      { name: '兑换券', value: 'EXCHANGE_COUPON' },
      // 满折券
      { name: '满折券', value: 'FULL_DISCOUNT_COUPON' },
    ],
    qrParamsFormData: [],
    refreshQrParamsFormData: '',
  },
  effects: {
    //新增和编辑表单
    *editActivityCoupon({ payload: { values }, callback }, { call }) {
      const {
        name,
        backgroundImg,
        coupons,
        date,
        appId,
        description,
        pagePath,
        id,
      } = values;
      const params = {
        name: name?.trim(),
        backgroundImg: backgroundImg[0],
        coupons: coupons?.map((item) => ({
          couponId: item.id,
          couponName: item.title,
          couponType: item.typeName,
          beginTime: item.beginTime,
          endTime: item.endTime,
        })),
        description: description?.trim(),
        beginDateTime: `${dayjs(date.startDate).format('YYYY-MM-DD')} 00:00:00`,
        endDateTime: `${dayjs(date.endDate).format('YYYY-MM-DD')} 23:59:59`,
        miniProgram: { appid: appId, pagePath: pagePath?.trim() },
        status: null,
      };
      const response = id
        ? yield call(voucherEdit.updateActivityCoupon, { ...params, id })
        : yield call(voucherEdit.AddActivityCoupon, params);
      callback &&
        typeof callback === 'function' &&
        response.code === 0 &&
        callback(response);
    },
    //获取详情
    *getDetail({ payload: { values } }, { call, put }) {
      const response = yield call(voucherEdit.getQueryActivityDetail, values);
      const res = response.data;
      const backgroundImg = [res.backgroundImg];
      const date = {
        startDate: res.beginDateTime,
        endDate: res.endDateTime,
      };
      const name = res.name;
      const description = res.description;
      const appId = res.miniProgram.appid;
      const pagePath = res.miniProgram.pagePath;
      const couponList = res.coupons?.map((item) => ({
        id: item.couponId,
        title: item.couponName,
        typeName: item.couponType,
        beginTime: item.beginTime,
        endTime: item.endTime,
      }));
      const defaultValues = {
        backgroundImg,
        date,
        name,
        description,
        appId,
        pagePath,
      };
      yield put({
        type: 'save',
        payload: {
          defaultValues,
          couponList,
        },
      });
    },
    //保存二维码
    *saveQrCodeGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(voucherEdit.saveQrCodeGroup, values);
      if (response?.code === 0) {
        return callback(response?.code);
      }
    },
    //下载二维码
    *downloadQRCode({ payload: { values }, callback }, { call }) {
      const response = yield call(voucherEdit.downloadQRCode, values);
      if (response?.code === 0) {
        return callback(response?.code);
      }
    },
    //查询pagepath
    *queryQrCodePagePath({ payload: { values }, callback }, { call }) {
      const response = yield call(voucherEdit.queryQrCodePagePath, values);
      if (response) {
        return callback(response);
      }
    },
    //点击添加一条小程序码参数
    *operationParamData(
      {
        payload: {
          values: { index, status },
        },
      },
      { select, put },
    ) {
      const { qrParamsFormData } = yield select((state) => state.voucherEdit);
      const qrParamsFormDataClone = [...qrParamsFormData];
      status === '1'
        ? qrParamsFormDataClone.splice(index + 1, 0, {
            name: '',
            value: '',
            id: guid(),
          })
        : qrParamsFormDataClone.splice(index, 1);
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: qrParamsFormDataClone,
          refreshQrParamsFormData: dayjs().valueOf(),
        },
      });
    },
    *setParamData({ payload: { values } }, { put, select }) {
      const { index, value, key } = values;
      const { qrParamsFormData } = yield select((state) => state.voucherEdit);
      const qrParamsFormDataClone = qrParamsFormData.map((item, i) => {
        if (index === i) {
          return key === 'name' ? { ...item, name: value } : { ...item, value };
        }
        return item;
      });
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: qrParamsFormDataClone,
          refreshPagePath: dayjs().valueOf(),
        },
      });
    },
    //新增小程序码
    *addQrCode(
      {
        payload: {
          values: { data },
        },
        callback,
      },
      { call },
    ) {
      const {
        appId,
        name,
        params,
        storeInfoList,
        storeKey,
        createType,
        importUrl,
        importFileName,
        id,
        pagePath,
      } = data;
      const storeInfoListResult =
        storeInfoList?.length > 0
          ? storeInfoList.map((item) => ({
              ...item,
              storeName: item.name || item.storeName,
            }))
          : [];
      const postParams = {
        name,
        appId,
        params: params?.length > 0 && createType === '1' ? params : [],
        id,
        storeInfoList: createType === '1' ? storeInfoListResult : [],
        createType,
        storeKey: createType === '1' ? storeKey : null,
        importUrl: createType === '2' ? importUrl : null,
        importFileName: createType === '2' ? importFileName : null,
        pagePath,
      };
      const response = yield call(voucherEdit.saveQrCodeGroup, postParams);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },
    //查询小程序码
    *getQueryQrCode({ payload: { values }, callback }, { call, put }) {
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: [{ name: 'id', value: values.id, id: guid() }],
          refreshQrParamsFormData: dayjs().valueOf(),
        },
      });
      const { urlType, ...p } = values;
      console.log({ urlType });
      const url = voucherEdit.qrcodeGroupInfo;
      const response = yield call(url, p);
      if (!response?.data) {
        return false;
      }
      const result = (obj) =>
        obj.map(({ name, value }) => ({ name, value, id: guid() }));
      const sl = response?.data?.storeInfoList.map((item) => ({
        ...item,
        name: item.storeName,
      }));
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData:
            response?.data?.params && response?.data?.params.length > 0
              ? result(response?.data?.params)
              : [{ name: 'id', value: values.id, id: guid() }],
          defaultFormData: response.data,
          defaultStores: sl || [],
          refreshQrParamsFormData: dayjs().valueOf(),
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //清除参数的事件
    *clearOperationParamData({ payload: { values } }, { select, put }) {
      const { qrParamsFormData } = yield select((state) => state.voucherEdit);
      const { key, index } = values;

      const newQrParamsFormData = qrParamsFormData.map((item, ind) => {
        if (index === ind) {
          return { ...item, [key]: '', id: guid() };
        }
        return item;
      });
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: newQrParamsFormData,
        },
      });
    },

    //initqrParamsFormData
    *initQrParamsFormData({ payload: { values } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: values,
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname === '/marketing/member_benefit_voucher/add' ||
          props.pathname === '/marketing/member_benefit_voucher/edit' ||
          props.pathname === '/marketing/member_benefit_voucher/detail' ||
          props.pathname === '/marketing/member_benefit_voucher/qr_code' ||
          props.pathname === '/marketing/luck_draw_view/qr_code'
        ) {
          dispatch({
            type: 'save',
            payload: {
              couponList: [],
              defaultValues: null,
              groupList: null,
              // qrParamsFormData: [],
              defaultFormData: null,
              autoReplyList: null,
              refreshQrParamsFormData: '',
              defaultStores: null,
            },
          });
        }
      });
    },
  },
};
